import React from 'react'

// material ui
import Box from '@mui/material/Box'

// containers
import ModalWrapper from 'components/shared/ModalWrapper'

// components
import Typography from '@mui/material/Typography'
import FormButton from 'components/atoms/FormButton'

export default function DeleteEntityModal(props) {
  const {
    entity, // via parent component
    modalId, // via parent component
    modalTitle, // via parent component
    loading, // via mutation
    onClickCancel, // via container
    onClickDelete // via container
  } = props

  return (
    <ModalWrapper title={modalTitle} modalId={modalId} closeButton>
      <Typography my={4} variant='body1' align='center'>
        Delete {entity.name || entity.firstName}? This cannot be undone.
      </Typography>
      <Box my={2} align='center'>
        <FormButton variant='contained' color='primary' onClick={onClickCancel}>
          Cancel
        </FormButton>
        <FormButton
          variant='contained'
          color='error'
          disabled={loading}
          onClick={onClickDelete}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </FormButton>
      </Box>
    </ModalWrapper>
  )
}
